(ns app.components.headers.styles
  (:require-macros)
  (:require
   [spade.core   :refer [defglobal defclass]]
   [garden.stylesheet :refer [at-media]]
   ))

(defclass title-md
  []
  {:font-weight "700"
   :font-size "36px"
   :font-family "'Poppins'"
   :margin "0px !important"})

(defclass title-lg
  []
  {:font-weight "700"
   :font-size "30px"
   :font-family "'Poppins'"
   :margin "0px !important"})

(defclass normal-md
  []
  {:font-size "14px"})

(defclass semibold-md
  []
  {:font-size "14px"
   :font-weight "700"})

(defclass regular-lg
  []
  {:font-size "20px"}
  [(at-media {:max-width "1340px"}
             {:font-size "15px"})])

(defclass semibold-lg
  []
  {:font-weight "700"
   :font-size "20px"})

(defclass bold-lg
  []
  {:font-weight "800"
   :font-size "20px"})

(defclass semibold-sm
  []
  {:font-weight "700"
   :font-size "12px"})

(defclass bold-sm
  []
  {:font-weight "800"
   :font-size "12px"
   :margin "0px !important"})

(defclass regular-sm
  []
  {:font-size "12px"
   :margin "0px !important"})

(defclass bold-xl
  []
  {:font-size "48px"
   :font-weight "700"
   :margin-top "0px !important"
   :margin-bottom "0px !important"}
  [(at-media {:max-width "1340px"}
             {:font-size "30px"
              :font-weight "700"
              :margin-top "0px !important"
              :margin-bottom "0px !important"})]
  [(at-media {:max-width "1280px"}
             {:font-size "24px"
              :font-weight "700"
              :margin-top "0px !important"
              :margin-bottom "0px !important"})])
